// Obtener moneda por país
export const getCurrencyByCountry = async (country: string): Promise<string> => {
  const data = await $fetch('/api-web/currenciesCountry') // obtener monedas por país
  const moneda = data?.find((item) => item.country_id === country)?.currency // elegir moneda dependiendo del país elegido
  return moneda ?? 'EUR'
}

// Obtener moneda por país
export const getLangByCountry = async (country: string): Promise<string> => {
  const data = await $fetch('/api-web/currenciesCountry') // obtener monedas por país
  const lang = data?.find((item) => item.country_id === country)?.lang // elegir moneda dependiendo del país elegido
  return lang?.toLowerCase() ?? 'es'
}